import { useRef } from 'react';
import { Routes, useLocation } from 'react-router-dom';

export default function PageTransition({ children }) {
  const location = useLocation();
  const isFirst = useRef(true);
  const animate = !isFirst.current;
  if (isFirst.current) isFirst.current = false;

  return (
    <div id="page-root">
      <div
        key={location.pathname}
        className={`page-transition-shell${animate ? ' page-enter' : ''}`}
      >
        <Routes location={location}>{children}</Routes>
      </div>
    </div>
  );
}
